"use client";

import Link from "next/link";
import Image from "next/image";
import { useRouter, usePathname } from "next/navigation";
import { useTranslations, useLocale } from "next-intl";
import { MobileMenu } from "./mobile-menu";
import { TryFreeButton } from "@/components/root/try-free-button";

export function Header() {
  const t = useTranslations("nav");
  const router = useRouter();
  const pathname = usePathname();
  const locale = useLocale();

  const isLanding = pathname.match(/^\/[a-z]{2}$/);

  const handleSectionClick = async (elementId: string) => {
    if (!isLanding) {
      await router.push(`/${locale}`);

      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 ${"bg-background backdrop-blur-sm "}`}
    >
      <div className="container flex items-center h-20">
        <Link href={`/${locale}`} className="flex items-center">
          <div className="relative h-7 sm:h-8 w-[140px] sm:w-[180px]">
            <Image
              src="/images/logo_plus_text.svg"
              alt="Logo"
              fill
              className="object-contain"
              priority
            />
          </div>
        </Link>

        <nav className="hidden md:flex items-center ml-12">
          <button
            onClick={() => handleSectionClick("faq")}
            className="text-sm font-medium mr-6 hover:text-gray-600"
          >
            {t("faq")}
          </button>
          <button
            onClick={() => handleSectionClick("features")}
            className="text-sm font-medium mr-6 hover:text-gray-600"
          >
            {t("features")}
          </button>
          <Link
            href={`/${locale}/blog`}
            className="text-sm font-medium mr-6 hover:text-gray-600"
          >
            {t("blog")}
          </Link>
          <Link
            href={`/${locale}/contacts`}
            className="text-sm font-medium hover:text-gray-600"
          >
            {t("contacts")}
          </Link>
        </nav>

        <div className="flex items-center ml-auto">
          <div className="hidden md:flex items-center space-x-4">
            <TryFreeButton />
          </div>
          <MobileMenu />
        </div>
      </div>
    </header>
  );
}
